export default {
    addGroup: 'Add to group',
    clientCount: 'Client Count',
    createGroup: "You haven't created any groups yet, <0>create one now</0>.",
    example: 'This is an super example',
    groupName: 'Group Name',
    memberCount: 'Member Count',
    removeGroup: 'Remove from group',
    subheader:
        'Documents and clients owned by a group are only visible to members of the group',
};
